import { render, staticRenderFns } from "./byTip.vue?vue&type=template&id=7222bb1c&scoped=true"
import script from "./byTip.vue?vue&type=script&lang=js"
export * from "./byTip.vue?vue&type=script&lang=js"
import style0 from "./byTip.vue?vue&type=style&index=0&id=7222bb1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222bb1c",
  null
  
)

export default component.exports